module.exports = __webpack_public_path__ + "img/swc-icon.05685b76.png";